let origin = window.ORIGIN;
//亮相台
const partyMemberUrl = `${origin}/gateway/hc-govern/miniapi/cp/cpList`;
//亮相台详情
const partyMemberDetailUrl = `${origin}/gateway/hc-govern/miniapi/cp/cpInfo`;
export { partyMemberUrl, partyMemberDetailUrl };
